import { useDispatch, useEffect, useGlobal, useState } from "reactn";

import { lamdaURL } from "../state/api";
import { useHistory } from "react-router-dom";

export const useGetReservationBlocksV3 = ({ user }) => {
	const history = useHistory();
	const enqueueReservationV3 = useDispatch("enqueueReservationV3");
	const pickReserveSaga = useDispatch("pickReserveSaga");
	const finishReserveSaga = useDispatch("finishReserveSaga");
	const finishReservationSaga = useDispatch("finishReservationSaga");
	const [myReservations] = useGlobal("myReservations");
	const { loading: reservationsV2Loader, current, byId } = myReservations;

	const [state, setState] = useState({
		blocks: null,
		loading: true,
		error: null,
		lineId: null,
	});
	const { blocks, loading, lineId } = state;

	const getReservationBlocks = async ({
		officeSlug,
		from,
		to,
		timezone,
		folder,
	}) => {
		const url = folder
			? `${lamdaURL}/reservations/api/v3/blocks/office/${officeSlug}?from=${from}&to=${to}&tz=${timezone}&folder=${folder}`
			: `${lamdaURL}/reservations/api/v3/blocks/office/${officeSlug}?from=${from}&to=${to}&tz=${timezone}`;
		setState({ blocks: null, loading: true, error: null });
		fetch(url, {
			headers: {
				authorization: user.token,
			},
		})
			.then((resp) => resp.json())
			.then((data) => {
				setState({
					loading: false,
					error: null,
					blocks: data,
				});
			})
			.catch((error) =>
				setState({ loading: false, error, blocks: null })
			);
	};

	const handleCreateReservation = ({
		lineSlug,
		officeSlug,
		from,
		to,
		lineId,
	}) => {
		setState((prevState) => ({ ...prevState, lineId }));
		enqueueReservationV3({
			lineSlug,
			officeSlug,
			from,
			to,
		});
		pickReserveSaga({
			lineSlug,
			officeSlug,
			_lineId: lineId,
			block: { from, to },
		});
	};

	useEffect(() => {
		if (current.length) {
			const { 0: reservationId } = current;
			const reservation = byId[reservationId];

			history.push(
				`/reserve/${reservation.office}/${reservation.line}/${reservationId}`
			);
		}
	}, [myReservations, reservationsV2Loader, current, byId, history]);

	useEffect(
		() => () => finishReserveSaga({ lineId }),
		[finishReserveSaga, lineId]
	);
	useEffect(() => () => finishReservationSaga({}), [finishReservationSaga]);

	return {
		blocks,
		loading: loading || reservationsV2Loader,
		getReservationBlocks,
		handleCreateReservation,
	};
};
